export default __webpack_public_path__ + "static/media/helmet-large-gr.f9d0fd55.png";